@if (variant() === 'row') {
  <div class="vbadge-row" [class.vbadge-row--meister]="istMeister()">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M12 2 4 5v7c0 5 4 9 8 10 4-1 8-5 8-10V5l-8-3Z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
    <div>
      <div class="vbadge-row__title">{{ badge().label }}</div>
      <div class="vbadge-row__sub">{{ sub() }}</div>
    </div>
  </div>
} @else {
  <span class="vbadge-pill" [class.vbadge-pill--meister]="istMeister()" [title]="title()">
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M12 2 4 5v7c0 5 4 9 8 10 4-1 8-5 8-10V5l-8-3Z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
    {{ badge().label }}
  </span>
}
